import React,{useState, useRef, useContext, useEffect, memo} from 'react'
import { Outlet, NavLink, Link, useLoaderData, useLocation } from "react-router-dom";
import { ThemeContext } from '../context/ThemeContext';
import { useDarkMode } from '../customhooks/ThemeHook';
import ProgressiveImage from './ProgressiveImage/FirstSlider';
import ProgressiveImageImg from './ProgressiveImage/FirstSlider';
import SEO from './SEO';
import { generateCollectionPageSchema, generateBreadcrumbSchema } from '../utils/structuredData';

import gsap from 'gsap'
/*import './work_4.css'*/



const WorkCat = memo( (props) => {

  //const featuredImage = 'https://discover.af-pictures.com/storage/app/uploads/public/c23/4f8/aee/thumb__1300_700_0_0_crop.jpg';
  const featuredImage = '/static/trans.gif';

  const theme = useContext(ThemeContext);
  const [darkMode, setDarkMode] = useDarkMode(false);
  const selectedWork = useRef();
  let projectsData = useLoaderData();
  let projects = projectsData.items;

  const location = useLocation();
  const [projectsGrid,setProjectsGrid] = useState(0);

    useEffect(() => {


      if( location.pathname.split('/').length === 2 ){
        setProjectsGrid(1);
      }else{
        setProjectsGrid(0);
      }



      if (location.hash) {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }, [location]);






  function transitionEffect(e){
    gsap.to(selectedWork.current,1,{ delay:1, opacity:0,ease:'easeIn' });
  }

  useEffect((props) => {


    var debugInput = document.querySelector("input");
   function updateDebugState() {
       document.body.classList.toggle('debug-on', debugInput.checked);
   }
   debugInput.addEventListener("click", updateDebugState);
   updateDebugState();
});







  // Generate SEO data for CINE category
  const breadcrumbs = [
    { name: 'Inicio', url: 'https://afpictures.com' },
    { name: 'Cine', url: 'https://afpictures.com/cine' }
  ];

  const collectionSchema = generateCollectionPageSchema('CINE', projects);
  const breadcrumbSchema = generateBreadcrumbSchema(breadcrumbs);
  const combinedSchema = [collectionSchema, breadcrumbSchema];

  return (
    <>
      {projectsGrid === 1 && (
        <SEO
          title="Cine - Catálogo de películas distribuidas | AF Pictures"
          description="Descubre nuestro catálogo completo de películas distribuidas. Distribución cinematográfica profesional de largometrajes, cortometrajes y producciones independientes."
          keywords="cine, largometrajes, cortometrajes, distribución cinematográfica, distribuidora de películas, cine independiente, distribución de cine, AF Pictures"
          url="https://afpictures.com/cine"
          image="https://afpictures.com/img/cine-category-og.jpg"
          structuredData={combinedSchema}
          type="website"
        />
      )}
      <div className="w-full text-center items-center">
      <div style={{maxWidth:1380+'px'}} className="mx-auto">
        { projectsGrid == 1 ?
          <>
            <div style={{backgroundImage: 'url(' + featuredImage + ')',backgroundPosition:'center', backgroundSize:'cover'}} className="relative background-cover h-[40vh]">
              <h1 style={{fontSize:'300%'}} className="text-center w-full pt-[20vh] text-8xl text-white">CATÁLOGO DE PRODUCCIONES</h1>
          </div>

          {/*   <div className="w-full text-gray-900 fadeIn pt-4">
           <h2 style={{fontSize:'2em'}} className="text-8xl font-medium text-center px-8 py-12 pb-4 text-inherit">Cinema</h2>
            </div>
            */}
            <div className="w-full py-8 pt-18 center bg-zinc-900">
                    <div className="py-2">

                      {projects.length > 0 ? projects.map((project,index) => (
                      index < 200 ?

                      <div className="py-4 grow inline-block w-[280px] text-white mx-1 items-center justify-center text-md font-medium" key={'doc-'+ index}>

                        <NavLink className="w-full" to={'../' + project.tax[0].slug+ '/'+project.slug} onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'cine' }}>

                        <picture id={'btn-' + index} className="link">
                        <ProgressiveImageImg
                        src={project.image_thumb.url}
                        placeholder={'/static/trans.gif'}
                        modal={theme.modal}
                        bg={'#333'}
                        imgMargin={props.imgMargin}
                        />
                        </picture>

                        {/*
                          <div className="flex flex-col p-1 space-y-1 text-left">
                            <p className="notranslate font-light text-gray-200 pb-2 pt-1 text-wrap">{project.name}</p>
                        </div>
                        */}

                      </NavLink>

                    </div>

                     : ''     ))  : <h3 className="text-white text-center text-2xl">Próximamente</h3>}

                    </div>
            </div>
          </>
           :
           '' }



      <div style={{display:'none'}} className="debug">
      <label><input type="checkbox"/>Debug </label>
    </div>

    <div className="z-900">
    <Outlet/>
  </div>

      </div>
    </div>
    </>
  )
})

export default WorkCat
